module.exports = __webpack_public_path__ + "img/freezerIcon.92edb3e9.png";